<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="关键词" property="keyword">
									<el-input
										v-model="searchForm.keyword"
										placeholder="请输入编号或设备名称"
										clearable
										@keyup.enter.native="getdevices"
									>
									</el-input>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="getdevices">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
							<div class="search_tools_text">设备列表
							<span style="margin-left: 15px">总设备数： {{total_data.total ? total_data.total : 0 }}</span>
							<span style="margin-left: 15px">在线率： {{total_data.online_rate ? total_data.online_rate : 0 }}%</span>
						</div>
						<!-- <div class="search-tools" style="display: flex;">
							<el-button type="primary" style="margin-left: 10px;" @click="exportExcel">导出</el-button>
							<el-button type="primary" @click="addHandle">新增</el-button>
							<el-button :disabled="delBtlStatu" type="danger" @click="delHandle()">批量删除</el-button>
						</div> -->
					</div>

					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<el-table-column prop="No" label="序号" sortable show-overflow-tooltip align="center">
							<template slot-scope="scope">
								{{'No.' + scope.row.No}}
							</template>
						</el-table-column>
						<el-table-column prop="productid" label="设备ID" show-overflow-tooltip align="center" />
						<el-table-column prop="tags" label="设备名称" sortable show-overflow-tooltip align="center" >
							<template slot-scope="scope">
								{{scope.row.tags.split('.')[2]}}
							</template>
						</el-table-column>
						<el-table-column prop="online_statu" label="状态" show-overflow-tooltip align="center">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.online_statu == 1" type="primary">在线</el-tag>
								<el-tag v-else type="danger">离线</el-tag>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column> -->
						<el-table-column
						  prop="icon"
						  fixed="right"
						  width="200px"
						  align="center"
						  label="操作">
							<template slot-scope="scope">
								<el-button type="text" @click="yuancheng(scope.row, '1')">远开</el-button>
								<el-button type="text" style="color: red;" @click="yuancheng(scope.row, '0')">远关</el-button>
								<el-button type="text" style="color: blue;" @click="viewHandle(scope.row)">近期订单</el-button>
								<!-- <el-button type="text" v-if="hasAuth('pay:room:electrichz')" style="color: orange;" @click="heZhaHandle(scope.row, '1')">合闸</el-button>
								<template>
									<el-popconfirm v-if="hasAuth('pay:room:electrichz')" style="margin-left: 10px" title="确定要拉闸吗？" @confirm="heZhaHandle(scope.row, '0')">
										<el-button type="text" style="color: red;" slot="reference">拉闸</el-button>
									</el-popconfirm>
								</template> -->
							</template>
						</el-table-column>
					</el-table>

					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						layout="total, sizes, prev, pager, next"
						:current-page="current"
						:page-size="20"
						:page-sizes="[20]"
						:total="total"
						:disabled="false">
						<!-- :total="computedTotal" -->
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--对话框-->
		<el-dialog
		  :title="titleDialog"
		  :visible.sync="dialogVisible"
		  width="70%"
		  top="10vh"
		  :before-close="handleClose"
		>
			<el-form class="form-main" size="mini" inline label-width="80px" label-position="right">
				<span>
					<el-form-item label="支付单号" property="outTradeNo">
						<span>
							<el-input v-model="dialogSearch.outTradeNo" placeholder="请输入订单号(16开头)" clearable></el-input>
						</span>
					</el-form-item>
					<el-form-item label="订单号" property="orderNo">
						<span>
							<el-input v-model="dialogSearch.orderNo" placeholder="请输入订单号(年份开头)" clearable></el-input>
						</span>
					</el-form-item>
					<el-form-item label="端口号" property="port">
						<span>
							<el-input v-model="dialogSearch.port" placeholder="请输入端口号" clearable></el-input>
						</span>
					</el-form-item>
					<el-form-item label="交易金额" property="amount">
						<span>
							<el-input v-model="dialogSearch.amount" placeholder="请输入金额（分）" clearable></el-input>
						</span>
					</el-form-item>
					<el-form-item label="交易日期" property="date">
						<span>
							<el-date-picker
								v-model="date"
								type="date"
								value-format="yyyy-MM-dd"
								format="yyyy-MM-dd"
								placeholder="选择日期">
							</el-date-picker>
						</span>
					</el-form-item>
				</span>
				<div class="search-box-button search-button search_box_button_right">
					<el-button size="mini" type="primary" @click.native.prevent="viewHandle">查 询</el-button>
					<el-button size="mini"  @click="resetdialogSearch">重 置</el-button>
				</div>
			</el-form>
		  	<el-table
				ref="multipleTable"
				:data="tableDataDialog"
				tooltip-effect="dark"
				border
				stripe
			>
				<el-table-column type="index" width="80" align="center" label="序号"></el-table-column>
				<el-table-column prop="openid" label="用户id" show-overflow-tooltip align="center"></el-table-column>
				<el-table-column prop="outTradeNo" label="支付单号" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span :title="scope.row.outTradeNo" style="cursor: pointer;">{{formatEllipsisOrderNo(scope.row.outTradeNo)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="orderNo" label="订单号" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span :title="scope.row.orderNo" style="cursor: pointer;">{{formatEllipsisOrderNo(scope.row.orderNo)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="port" label="端口" show-overflow-tooltip align="center"></el-table-column>
				<el-table-column prop="amount" label="金额（元）" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>{{scope.row.amount ? '￥' + (scope.row.amount/100) : '-'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="支付结余时间" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>{{(scope.row.deductMinutes || '-')}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="paymentStatus" label="支付状态" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.paymentStatus == 1" type="primary">已支付</el-tag>
						<el-tag v-else type="danger">未支付</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" show-overflow-tooltip align="center"></el-table-column>
				<el-table-column label="操作" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.paymentStatus == 1" type="text" @click="viewHandleDetail(scope.row)">用电详情</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination
				@size-change="handleSizeChangeDialog"
				@current-change="handleCurrentChangeDialog"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50]"
				:current-page="currentDialog"
				:page-size="sizeDialog"
				:total="totalDialog">
			</el-pagination>
			<div slot="footer" class="dialog-footer" style="margin-top: 20px;text-align: center;">
				<el-button @click="handleClose">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 远开远关端口选择弹窗 -->
		<el-dialog
			:title="remoteAction === 'open' ? '远开操作' : '远关操作'"
			:visible.sync="showPortModal"
			width="500px"
			align="center"
			center=""
			:before-close="closePortModal"
		>
			<div v-if="currentDevice">
				<div style="margin-bottom: 15px;">
					<div style="font-size: 16px; font-weight: bold; margin-bottom: 5px;">
						{{ currentDevice.tags ? currentDevice.tags.split('.')[2] : '设备' }}（序号：{{currentDevice.tags ? currentDevice.tags.split('.').slice(0, 2).join('.') : currentDevice.id}}）
					</div>
					<div style="font-size: 14px; color: #666;">
						产品ID：{{currentDevice.productid || currentDevice.deviceId || '无'}}
					</div>
				</div>
				<div style="margin-bottom: 20px;">
					<div style="font-size: 14px; margin-bottom: 10px; color: #333;">选择端口：</div>
					<div v-if="loadingPortStatus" style="text-align: center; padding: 20px; color: #999;">
						正在加载端口状态...
					</div>
					<div v-else class="ports-grid">
						<div
							v-for="port in portList"
							:key="port.port"
							class="port-item"
							:class="{ 
								selected: selectedPort === port.port, 
								disabled: remoteAction === 'open' && port.statu != 1,
								running: port.statu == 2,
								idle: port.statu == 1
							}"
							:style="{
								borderColor: selectedPort === port.port ? '#409EFF' : (port.statu_color || '#e0e0e0'),
								backgroundColor: selectedPort === port.port ? '#ecf5ff' : (port.statu == 2 ? '#fff1f0' : '#f6ffed')
							}"
							@click="selectPort(port)">
							<div style="font-weight: bold; margin-bottom: 3px;">{{ port.port }}</div>
							<div style="font-size: 12px; color: #666;">
								{{ port.statu_text || (port.statu == 1 ? '空闲' : '充电中') }}
							</div>
						</div>
					</div>
				</div>
				<div v-if="remoteAction === 'open'" style="margin-bottom: 20px;">
					<el-form :model="{ chargingMinutes: chargingMinutes }" label-width="120px">
						<el-form-item label="充电时长 (分钟)">
							<el-input
								type="number"
								v-model.number="chargingMinutes"
								placeholder="请输入充电时长，例如 240"
								min="1"
								max="999"
								style="width: 100%">
							</el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closePortModal">取 消</el-button>
				<el-button
					type="primary"
					:disabled="!selectedPort || (remoteAction === 'open' && !chargingMinutes)"
					@click="handleRemoteAction">
					{{ remoteAction === 'open' ? '远程开机' : '远程关机' }}
				</el-button>
			</div>
		</el-dialog>

		<!-- 订单详情弹窗 -->
		<el-dialog
			title="订单详情"
			:visible.sync="detailDialogVisible"
			width="800px"
			top="10vh"
			:before-close="closeDetailDialog"
		>
			<div v-if="orderDetail" class="order-detail-container">
				<!-- 订单基本信息 -->
				<div class="detail-section">
					<div class="section-title">
						<i class="el-icon-document"></i>
						<span>订单信息</span>
					</div>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="24">
							<div class="detail-item">
								<span class="detail-label">支付订单号：</span>
								<span class="detail-value">{{ clickRow.outTradeNo || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">openId：</span>
								<span class="detail-value">{{ clickRow.openid || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">订单号：</span>
								<span class="detail-value">{{ clickRow.orderNo || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">设备位置：</span>
								<span class="detail-value">{{ orderDetail.device_tags || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">端口号：</span>
								<span class="detail-value">{{ orderDetail.port || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">支付费用：</span>
								<span class="detail-value highlight" v-if="clickRow.amount">¥{{ formatAmount(clickRow.amount || 0) }}</span>
								<span class="detail-value highlight" v-if="clickRow.deductMinutes && clickRow.amount">+</span>
								<span class="detail-value highlight" v-if="clickRow.deductMinutes">{{ clickRow.deductMinutes ? clickRow.deductMinutes + '结余时间' : '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">支付状态：</span>
								<el-tag v-if="clickRow.paymentStatus == 1" type="success">已支付</el-tag>
								<el-tag v-else type="danger">未支付</el-tag>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">下单时长：</span>
								<span class="detail-value">{{ clickRow.chargingMinutes || '0' }}</span>
								<span class="detail-label">分钟</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">下单时间：</span>
								<span class="detail-value">{{ clickRow.createTime || '-' }}</span>
							</div>
						</el-col>
					</el-row>
				</div>

				<!-- 充电时间信息 -->
				<div class="detail-section">
					<div class="section-title">
						<i class="el-icon-time"></i>
						<span>充电记录</span>
					</div>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">实时功率：</span>
								<span class="detail-value">{{ orderDetail.power || '0' }}W
									<el-button title="实时功率曲线图" type="text" icon="el-icon-data-line" @click="togglePowerChart" style="margin-left: 20px;"></el-button>
								</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">消耗电量：</span>
								<span class="detail-value">{{ orderDetail.elec || '0' }}度</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">充电状态：</span>
								<el-tag v-if="orderDetail.is_running == 1" type="primary">充电中</el-tag>
								<el-tag v-else type="info">充电结束</el-tag>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">实际充电时长：</span>
								<span class="detail-value">{{ orderDetail.is_running == 1 ? orderDetail.minute || '-' : orderDetail.minute}}</span>
								<span class="detail-label">分钟</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">开始充电时间：</span>
								<span class="detail-value">{{ orderDetail.start_date || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">结束充电时间：</span>
								<span class="detail-value">{{ orderDetail.end_date || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-if="orderDetail.is_running == 1" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">已充电时长：</span>
								<span class="detail-value">{{ getChargedDuration() }}分钟</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">剩余时长：</span>
								<span class="detail-value">{{ getRemainingDuration() }}分钟</span>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="orderDetail.is_running != 1" :gutter="20" class="detail-row">
						<el-col :span="24">
							<div class="detail-item">
								<span class="detail-label">结束原因：</span>
								<span class="detail-value highlight">{{ orderDetail.reason >= 0 ? reasonArr.find(item => item.value == orderDetail.reason).label : '-' }}</span>
							</div>
						</el-col>
					</el-row>
				</div>

				<!-- ECharts container -->
				<div v-if="showPowerChart" ref="powerChart" style="width: 100%; height: 300px; margin-top: 20px;"></div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDetailDialog">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {getDevice, getDevices, getRecordes, getPortStatus, remoteOpen, remoteClose, getOrderInfo} from '../../apis/devices.js'
import * as echarts from 'echarts';
import dayjs from 'dayjs';
export default {
	name: "Device",	// 设备管理
	data() {
		return {
			loading: true,
			nowDate: '',

			searchForm: {},
			delBtlStatu: true,

			total: 0,
			hasMore: false,
			current: 1,
			total_data: {},

			// 弹窗的数据
			totalDialog: 0,
			sizeDialog: 10,
			currentDialog: 1,
			tableDataDialog: [],
			titleDialog: '记录',
			getParams: {},
			dialogSearch: {},
			date: '',

			dialogVisible: false,
			title: '新增',
			editForm: {},

			tableData: [],

			editFormRules: {
				priceName: [
					{required: true, message: '请输入单价名称', trigger: 'blur'}
				],
				price: [
					{required: true, message: '请输入单价', trigger: 'blur'}
				],
				startDate: [
					{required: true, message: '请选择生效日期', trigger: 'change'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
			
			// 远开远关弹窗相关
			showPortModal: false,
			currentDevice: null,
			selectedPort: null,
			chargingMinutes: 480,
			remoteAction: '', // 'open' 或 'close'
			portList: [], // 端口状态列表
			loadingPortStatus: false, // 加载端口状态中
			
			// 订单详情弹窗相关
			detailDialogVisible: false,
			orderDetail: null, // 订单详情数据
			clickRow: null, // 点击的行数据
			
			showPowerChart: false, // For toggling the power chart
			powerChartInstance: null, // To hold the chart instance

			reasonArr:  [
				{value: 0 , label: '充电时间/电量用完了'},
				{value: 1 , label: '充满了或充电功率低'},  //插头脱落或充电器停止充电
				{value: 2 , label: '充电满了，自动停止'},
				{value: 3 , label: '充电结束'},          //充电状态异常，请检查充电器连接
				{value: 4 , label: 'D功率过大，充电结束'}, //因充电器功率超过充电站的单路最大输出功率，停止输出
				{value: 5 , label: '刷卡退费结束'},
				{value: 6 , label: '充电功率低停止充电'},  //未接充电器
				{value: 7 , label: '系统关机'},
				{value: 8 , label: '烟雾报警停止'},
				{value: 9 , label: '过压'},
				{value: 10, label:  '欠压'},
				{value: 11, label:  '高温'},
				{value: 12, label:  'Z功率过大，充电结束'}, //因充电器功率超过充电站的总最大输出功率，切断输出
				{value: 13, label:  '因固件升级，充电结束'},
				{value: 14, label:  '强磁'},
				{value: 15, label:  '功率过大/短路'},
				{value: 71, label:  '管理后台结束充电'},
				{value: 72, label:  '商户后台结束充电'},
				{value: 73, label:  '用户手动结束充电'},
				{value: 88, label:  '充电费用用完了'},     //充电费+服务费>预支付金额，充电结束
				{value: 98, label:  '开机失败'},          //既定时间内，未收到开机指令答复
				{value: 99, label:  '充电结束。'},        //既定时间内，未上报结束指令，后台自动中断订单
			]
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		},
		// 根据 hasMore 和 total 计算实际总数，用于分页组件判断是否有下一页
		computedTotal: function() {
			if (this.hasMore) {
				// 如果有下一页，计算一个大于当前显示的总数
				// 当前页数 * 每页数量 + 当前页数据量，表示至少还有一页
				// 这样分页组件会显示"下一页"按钮可用
				const currentPageItems = this.tableData.length
				return (this.current - 1) * 20 + currentPageItems + 1
			} else {
				// 如果没有下一页，返回实际总数
				// 这样分页组件会正确显示总页数，并禁用"下一页"按钮
				return this.total || 0
			}
		}
	},
	created() {
		let t = new Date()
		let date = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
		this.date = date
		this.nowDate = date
		// this.getdevices()

		if (this.$route.query.deviceName) {
			this.searchForm.keyword = this.$route.query.deviceName
			this.getdevices()
		} else {
			this.searchForm = {}
			this.getdevices()
		}
	},
	methods: {
		resetSearchForm() {
			this.searchForm = {}
			this.getdevices()
			this.current = 1
		},
		resetdialogSearch() {
			this.dialogSearch = {}
			this.date = this.nowDate
			this.currentDialog = 1
			this.viewHandle()
		},

				// 计算已充电时长 (分钟)
		getChargedDuration() {
			if (!this.orderDetail || !this.orderDetail.start_date) return 0;
			const start = dayjs(this.orderDetail.start_date);
			const now = dayjs();
			const diff = now.diff(start, 'minute');
			return diff > 0 ? diff : 0;
		},

		// 计算剩余时长 (分钟)
		getRemainingDuration() {
			const charged = this.getChargedDuration();
			const total = Number(this.clickRow.chargingMinutes) || 0;
			const remaining = total - charged;
			return remaining > 0 ? remaining : 0;
		},

		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.getdevices()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getdevices()
		},

		handleSizeChangeDialog(val) {
			this.sizeDialog = val
			this.viewHandle()
		},
		handleCurrentChangeDialog(val) {
			this.currentDialog = val
			this.viewHandle()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.dialogVisible = false
			this.currentDialog = 1
			this.sizeDialog = 10
			this.totalDialog = 0
			this.tableDataDialog = []

			let t = new Date()
			let t1 = new Date(new Date() - 7 * 24 * 60 * 60 * 1000)
			this.dateRange = [t1.getFullYear() + '-' + (t1.getMonth() + 1) + '-' + t1.getDate(), t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()]
		},
		getdevices() {
			getDevices({page: this.current, ...this.searchForm}).then(res => res.data).then(res => {
				// console.log(res);
				if (res.code == 200) {
					// 充电桩接口返回的参数
					let res1 = res.data
					if (res1.err_code == 200) {
						this.tableData = res1.data.lists.map(it => ({
							...it, No: parseInt(it.tags.split('.')[1])
						})).sort((a, b) => a.No - b.No)
						this.total = res1.data.total
						this.hasMore = res1.data.hasMore
						this.total_data = res1.data.total_data
					} else {
						this.$message({
							type: 'error',
							message: res.err_msg
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.message
					})
				}
				this.loading = false
			})
		},
		exportExcel(type) {
			const loading = this.$loading({
				text: '加载中...',
			});
			if (type == 'dushu') {
				exportDeviceRecord({elecNo: this.getParams.elecNo, beginDate: this.dateRange[0], endDate: this.dateRange[1]}).then(res => res.data).then(res => {
					loading.close()
					if (res.code == 200) {
						if (res.data.length) {
							let excelData = res.data.map((it, index) => ({index: index + 1,mc: `${it.buildingName}-${it.roomNo}`, bh: it.elecNo, qm: it.inAmount, zm: it.outAmount, ds: it.thisAmount.toFixed(2), zmsj: it.recordDate}))
							this.getExcel(excelData, type)
						} else {
							this.$message({
								type: 'error',
								message: "没有可导数据"
							})
						}
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			} else {
				export_excel({current: this.current, size: this.size, ...this.searchForm}).then(res => res.data).then(res => {
					loading.close()
					if (res.code == 200) {
						if (res.data.length) {
							let excelData = res.data.map((it, index) => ({index: index + 1,mc: `${it.buildingName}-${it.roomNo}`, bh: it.elecNo, qm: it.startAmount, qmsj: it.startTime, zm: it.lastAmount, zmsj: it.lastTime, zt: it.onLine ? '在线' : '离线', updateTime: it.updateTime}))
							this.getExcel(excelData)
						} else {
							this.$message({
								type: 'error',
								message: "没有可导数据"
							})
						}
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			}
		},
		viewHandle(row) {
			const loading = this.$loading({
				text: '加载中...',
			});

			let productid = ""
			let tags = ""
			if (row && row.productid) {
				productid = row.productid
				tags = row.tags
				this.titleDialog = `近期订单（${tags}）`
				this.getParams = {
					productid: row.productid,
					tags: row.tags
				}
			} else {
				productid = this.getParams.productid
				tags = this.getParams.tags
			}

			getRecordes({
				pageNum: this.currentDialog, pageSize: this.sizeDialog, date: this.date, deviceId: productid,
				...this.dialogSearch
			}).then(res => res.data).then(res => {
				loading.close()
				this.dialogVisible = true
				this.tableDataDialog = res.data.list
				this.totalDialog = res.data.total
				// console.log(res);
			})
		},

		formatEllipsisOrderNo(orderNo) {
			if (!orderNo || typeof orderNo !== 'string') return orderNo || '';
			
			// 默认前后各保留4位
			const keepLength = 6;
			
			if (orderNo.length <= keepLength * 2 + 3) {
			return orderNo;
			}
			
			const prefix = orderNo.substring(0, keepLength);
			const suffix = orderNo.substring(orderNo.length - keepLength);
			return `${prefix}...${suffix}`;
		},

		// 查看订单详情
		viewHandleDetail(row) {
			this.clickRow = row
			// console.log(row);

			this.showPowerChart = false; // Reset chart visibility when opening a new detail view
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose();
				this.powerChartInstance = null;
			}
			
			// 检查订单号是否存在
			if (!row.chargingOrderNo) {
				this.$message({
					type: 'warning',
					message: '订单号不存在，无法查看详情'
				})
				return
			}

			const loading = this.$loading({
				text: '加载订单详情...',
				lock: true
			})

			getOrderInfo({
				orderNo: row.chargingOrderNo
			}).then(res => res.data).then(res => {
				loading.close()
				if (res.code == 200 && res.data) {
					this.orderDetail = res.data.data
					this.detailDialogVisible = true
				} else {
					this.$message({
						type: 'error',
						message: res.message || '获取订单详情失败'
					})
				}
			}).catch(error => {
				loading.close()
				console.error('获取订单详情失败:', error)
				this.$message({
					type: 'error',
					message: '获取订单详情失败，请稍后再试'
				})
			})
		},

		// 格式化金额（分转元）
		formatAmount(amount) {
			if (!amount && amount !== 0) return '0.00'
			// 如果金额很大，可能是分，转换为元
			// if (amount > 1000) {
				amount = amount / 100
			// }
			return parseFloat(amount).toFixed(2)
		},

		// 格式化功率
		formatPower(power) {
			if (!power && power !== 0) return '-'
			return parseFloat(power).toFixed(2)
		},

		getReasonLabel(reason) {
			if (reason === undefined || reason === null || reason < 0) return '-';
			const item = this.reasonArr.find(item => item.value == reason);
			return item ? item.label : `未知原因(${reason})`;
		},

		// 计算已充电时长 (分钟)
		getChargedDuration() {
			if (!this.orderDetail || !this.orderDetail.start_date) return 0;
			const start = dayjs(this.orderDetail.start_date);
			const now = dayjs();
			const diff = now.diff(start, 'minute');
			return diff > 0 ? diff : 0;
		},

		// 计算剩余时长 (分钟)
		getRemainingDuration() {
			const charged = this.getChargedDuration();
			const total = Number(this.clickRow.chargingMinutes) || 0;
			const remaining = total - charged;
			return remaining > 0 ? remaining : 0;
		},

		closeDetailDialog() {
			this.detailDialogVisible = false;
			this.orderDetail = null;
			this.showPowerChart = false;
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose();
				this.powerChartInstance = null;
			}
		},

		togglePowerChart() {
			this.showPowerChart = !this.showPowerChart;
			if (this.showPowerChart) {
				this.$nextTick(() => {
					this.initPowerChart();
				});
			} else {
				if (this.powerChartInstance) {
					this.powerChartInstance.dispose();
					this.powerChartInstance = null;
				}
			}
		},

		initPowerChart() {
			if (!this.orderDetail || !this.orderDetail.powers || this.orderDetail.powers.length === 0) {
				this.$message.info('暂无功率数据');
				this.showPowerChart = false;
				return;
			}
			const Arr = JSON.parse(JSON.stringify(this.orderDetail.powers));
			Arr.sort((a, b) => parseInt(a.create_time) - parseInt(b.create_time));
			// Arr.reverse()
			const chartDom = this.$refs.powerChart;
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose();
			}
			this.powerChartInstance = echarts.init(chartDom);

			const option = {
				title: {
					text: '实时功率曲线',
					left: 'center'
				},
				tooltip: {
					trigger: 'axis'
				},
				xAxis: {
					type: 'category',
					data: Arr.map(item => item.create_time_str),
					axisLabel: {
						rotate: 45, // Rotate labels to prevent overlap
						interval: 'auto'
					}
				},
				yAxis: {
					type: 'value',
					name: '功率 (W)',
					axisLabel: {
						formatter: '{value} W'
					}
				},
				series: [
					{
						name: '功率',
						type: 'line',
						data: Arr.map(item => item.instand_power),
						smooth: true
					}
				],
				grid: {
					left: '10%',
					right: '10%',
					bottom: '15%'
				},
				dataZoom: [ // Add data zoom for better navigation on long time series
					{
						type: 'inside',
						start: 0,
						end: 100
					},
					{
						start: 0,
						end: 100
					}
				],
			};
			this.powerChartInstance.setOption(option);
		},

		// 远开远关相关方法
		yuancheng(row, action) {
			// action: '1' 表示远开, '0' 表示远关
			this.currentDevice = row
			this.selectedPort = null
			this.chargingMinutes = 480
			this.remoteAction = action === '1' ? 'open' : 'close'
			this.portList = []
			this.loadingPortStatus = true
			
			// 先获取端口状态
			const productId = row.productid || row.deviceId
			if (!productId) {
				this.$message({
					type: 'error',
					message: '设备ID不存在'
				})
				this.loadingPortStatus = false
				return
			}
			
			getPortStatus({
				productId: productId
			}).then(res => res.data).then(res => {
				this.loadingPortStatus = false
				if (res.code == 200 && res.data) {
					// 使用接口返回的端口列表
					this.portList = res.data.data.port_lists || []
					// 如果没有端口数据，初始化10个端口
					if (this.portList.length === 0) {
						this.initEmptyPorts(productId)
					}
					this.showPortModal = true
				} else {
					// 如果接口失败，初始化空端口
					this.initEmptyPorts(productId)
					this.showPortModal = true
					this.$message({
						type: 'warning',
						message: res.message || '获取端口状态失败，已使用默认端口'
					})
				}
			}).catch(error => {
				console.error('获取端口状态失败:', error)
				this.loadingPortStatus = false
				// 出错时也初始化空端口
				this.initEmptyPorts(productId)
				this.showPortModal = true
				this.$message({
					type: 'warning',
					message: '获取端口状态失败，已使用默认端口'
				})
			})
		},

		// 初始化空端口（当接口失败时）
		initEmptyPorts(productId) {
			const ports = []
			for (let i = 1; i <= 10; i++) {
				ports.push({
					port: i,
					statu: 1, // 空闲
					statu_text: '空闲',
					statu_color: '#52c41a'
				})
			}
			this.portList = ports
		},
		closePortModal() {
			this.showPortModal = false
			this.currentDevice = null
			this.selectedPort = null
			this.chargingMinutes = 480
			this.remoteAction = ''
			this.portList = []
		},
		selectPort(port) {
			// 如果是数字，表示直接选择端口号
			if (typeof port === 'number') {
				this.selectedPort = port
				return
			}
			// 如果是端口对象
			const portNum = port.port || port
			// 如果是远开操作，只能选择空闲的端口（statu == 1）
			if (this.remoteAction === 'open' && port.statu != 1) {
				this.$message({
					type: 'warning',
					message: '该端口正在充电中，请选择空闲端口'
				})
				return
			}
			// 如果点击的是已选中的端口，取消选择
			if (this.selectedPort == portNum) {
				this.selectedPort = null
			} else {
				this.selectedPort = portNum
			}
		},
		handleRemoteAction() {
			if (!this.currentDevice || !this.selectedPort) {
				this.$message({
					type: 'warning',
					message: '请选择端口'
				})
				return
			}

			const productId = this.currentDevice.productid || this.currentDevice.deviceId
			if (!productId) {
				this.$message({
					type: 'error',
					message: '设备ID不存在'
				})
				return
			}

			if (this.remoteAction === 'open') {
				// 远开需要充电时长
				if (!this.chargingMinutes || this.chargingMinutes <= 0) {
					this.$message({
						type: 'warning',
						message: '请输入有效的充电时长'
					})
					return
				}
				remoteOpen({
					productId: productId,
					port: this.selectedPort,
					stall: this.chargingMinutes
				}).then(res => res.data).then(res => {
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: '远开指令已发送'
						})
						this.closePortModal()
					} else {
						this.$message({
							type: 'error',
							message: res.message || '远开失败'
						})
					}
				}).catch(err => {
					console.error('远开失败:', err)
					this.$message({
						type: 'error',
						message: '远开失败，请稍后再试'
					})
				})
			} else {
				// 远关
				remoteClose({
					productId: productId,
					port: this.selectedPort
				}).then(res => res.data).then(res => {
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: '远关指令已发送'
						})
						this.closePortModal()
					} else {
						this.$message({
							type: 'error',
							message: res.message || '远关失败'
						})
					}
				}).catch(err => {
					console.error('远关失败:', err)
					this.$message({
						type: 'error',
						message: '远关失败，请稍后再试'
					})
				})
			}
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// console.log(this.editForm);
					if (this.editForm.id) {
						updateDj({...this.editForm, price: parseFloat(this.editForm.price)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getdevices()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					} else {
						addDj({...this.editForm, price: parseFloat(this.editForm.price)}).then(res => {
							this.$message({
								showClose: true,
								message: '操作成功',
								type: 'success',
								onClose: () => {
									this.getdevices()
								}
							});
							this.dialogVisible = false
						  	this.resetForm(formName)
						})
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center;
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

.ports-grid {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 10px;
	margin-bottom: 20px;
}

.port-item {
	padding: 12px 6px;
	text-align: center;
	border-radius: 8px;
	border: 2px solid #e0e0e0;
	cursor: pointer;
	transition: all 0.2s;
	font-weight: 600;
	color: #333;
	background: #f8f8f8;
}

.port-item:hover {
	border-color: #409EFF;
	background: #ecf5ff;
}

.port-item.selected {
	border-color: #409EFF;
	background: #409EFF;
	color: #333;
	box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.port-item.disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.port-item.running {
	border-color: #F56C6C;
}

.port-item.idle {
	border-color: #67C23A;
}

/* 订单详情弹窗样式 */
.order-detail-container {
	padding: 10px 0;
}

.detail-section {
	margin-bottom: 30px;
	padding: 20px;
	background: #f8f9fa;
	border-radius: 8px;
	border-left: 4px solid #409EFF;
}

.section-title {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 20px;
	padding-bottom: 10px;
	border-bottom: 2px solid #e4e7ed;
}

.section-title i {
	font-size: 18px;
	margin-right: 8px;
	color: #409EFF;
}

.detail-row {
	margin-bottom: 15px;
}

.detail-row:last-child {
	margin-bottom: 0;
}

.detail-item {
	display: flex;
	align-items: center;
	min-height: 32px;
}

.detail-label {
	font-size: 14px;
	color: #606266;
	font-weight: 500;
	min-width: 120px;
	flex-shrink: 0;
}

.detail-value {
	font-size: 14px;
	color: #303133;
	flex: 1;
	word-break: break-all;
}

.detail-value.highlight {
	color: #409EFF;
	font-weight: 600;
	font-size: 15px;
}

</style>